import e from "@dialpad/dialtone-tokens/layered/themes/tokens-trita-colors.css?inline";
//#region themes/trita.js
var t = { brand: {
	css: e,
	name: "trita"
} };
//#endregion
export { t as default };
